import React from "react"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface AddressPreviewCardProps {
  title?: string

  street?: string

  number?: string

  neighborhood?: string

  city?: string

  state?: string

  cep?: string

  complement?: string

  latitude?: number

  longitude?: number

  className?: string
}

export const AddressPreviewCard: React.FC<AddressPreviewCardProps> = ({
  title,
  street,
  number,
  neighborhood,
  city,
  state,
  cep,
  complement,
  latitude,
  longitude,
  className = "",
}) => {
  const { t } = useTranslation()

  const resolvedTitle = title ?? t("address:selected_address")
  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <div
        className={`rounded-xl ring-2 ring-orange-200 bg-white/80 backdrop-blur-sm p-5 transition-all duration-200 hover:border-gray-200 ${className}`}
      >
        <div className="mb-3">
          <p className="text-[10px] font-medium text-gray-400 uppercase tracking-widest">{resolvedTitle}</p>
        </div>

        <div className="space-y-1">
          <p className="text-sm font-semibold text-gray-900 leading-tight">
            {street || "-"} {number || ""}
          </p>

          <p className="text-sm text-gray-500">{neighborhood || "-"}</p>

          <p className="text-sm text-gray-500">
            {city || "-"}, {state || "-"} <span className="text-gray-400">• {cep || "-"}</span>
          </p>

          {complement && <p className="text-sm text-gray-800">{complement}</p>}
        </div>

        <div className="mt-4 pt-3 border-t border-gray-300 flex justify-between items-center text-[11px] text-gray-600 font-mono">
          <span>
            {t("address:lat")} {latitude ?? "-"}
          </span>
          <span>
            {t("address:lng")} {longitude ?? "-"}
          </span>
        </div>
      </div>
    </Animate>
  )
}
